import React from 'react';
import fr from 'facet-rest';
import { pickFunction } from 'Helpers/Affordances';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import DefaultInsuranceAgents from './DefaultInsuranceAgent';

const InsuranceAgentsPicker = (props) => {
  const { householdResource } = useSimpleHousehold();

  return pickFunction(householdResource, {
    [fr.relationships.default.name]: () => {
      return (
        <DefaultInsuranceAgents {...props} />
      );
    },
  });
};

export default InsuranceAgentsPicker;
